import { Injectable } from '@angular/core';
import { IIntroduction } from '@shared/models';
import { Observable, take } from 'rxjs';
import { PATH } from 'src/app/config/path.configs';
import { RestApiService } from './rest-api.service';

@Injectable({
    providedIn: 'root',
})
export class IntroductionService {
    constructor(private readonly restApi: RestApiService) {}

    public getIntroduction(questionnaireId: string, languageCode: string = null): Observable<IIntroduction> {
        var url = `${PATH.QUESTIONNAIRE}/${questionnaireId}/${PATH.INTRODUCTION}`
        if(languageCode){
            url = url + `?lang=${languageCode}`
        }
            
        return this.restApi
            .get<IIntroduction>(
                url
            )
            .pipe(take(1));
    }
}
